import { render, staticRenderFns } from "./UketsukeApp.vue?vue&type=template&id=d1af46ce&"
import script from "./UketsukeApp.vue?vue&type=script&lang=ts&"
export * from "./UketsukeApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports